import axios from "axios";

const TOKEN_KEY = "llh_token";

export const tokens = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

const api = axios.create({ baseURL: "/api" });

api.interceptors.request.use((config) => {
  const t = tokens.get();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// On an expired/invalid token, clear it and bounce to the landing page.
api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response && err.response.status === 401) {
      tokens.clear();
      if (window.location.pathname !== "/") window.location.assign("/");
    }
    return Promise.reject(err);
  }
);

// Pull a human-readable message out of an axios error.
export const errMsg = (e, fallback = "Something went wrong") =>
  (e && e.response && e.response.data && e.response.data.error) || fallback;

// keepalive JSON write. Uses raw fetch with keepalive:true so the request
// survives an unload (tab close / app background) instead of being dropped like
// a fire-and-forget axios call. Mirrors the transport saveSettings uses in
// Ironlifts. Throws on non-2xx; the caller surfaces success/failure in its UI.
export async function keepaliveJson(method, path, body) {
  const res = await fetch(`/api${path}`, {
    method,
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${tokens.get()}`,
    },
    body: JSON.stringify(body),
  });
  if (!res.ok) {
    // Surface the server's JSON error body (e.g. 409 "Email already in use") in
    // the same shape axios produces, so errMsg() reads e.response.data.error
    // exactly as it did before the transport swap. keepalive constrains the
    // request, not the response: the body is readable in every case except an
    // actual page unload, and then there is no UI left to show a message anyway.
    const err = new Error(`HTTP ${res.status}`);
    try { err.response = { data: await res.json() }; } catch { /* non-JSON or empty body */ }
    throw err;
  }
  return res;
}

export default api;
